module.exports = __webpack_public_path__ + "static/media/dark_delphi.6f852f74.png";